export const INVITE_SHARE_KINDS = [
  "guardianFamily",
  "guardianStudent",
  "memberTeacher",
  "memberAdmin",
  "studentSelf",
  "ownerOnboarding"
] as const;

export type InviteShareKind = (typeof INVITE_SHARE_KINDS)[number];

type InviteShareDefinition = {
  title: string;
  actionDescription: string;
};

const INVITE_SHARE_DEFINITIONS: Record<InviteShareKind, InviteShareDefinition> = {
  guardianFamily: {
    title: "保護者向け招待",
    actionDescription: "生徒との紐付けを行ってください。"
  },
  guardianStudent: {
    title: "保護者向け招待",
    actionDescription: "生徒との紐付けを行ってください。"
  },
  memberTeacher: {
    title: "講師向け招待",
    actionDescription: "講師アカウントの登録を行ってください。"
  },
  memberAdmin: {
    title: "管理者向け招待",
    actionDescription: "管理者アカウントの登録を行ってください。"
  },
  studentSelf: {
    title: "生徒本人用招待",
    actionDescription: "生徒本人のアカウント登録を行ってください。"
  },
  ownerOnboarding: {
    title: "初期設定のご案内",
    actionDescription: "初期設定を行ってください。"
  }
};

export function resolveInviteTenantName({
  brandName,
  displayName,
  tenantSlug
}: {
  brandName?: string | null | undefined;
  displayName?: string | null | undefined;
  tenantSlug?: string | null | undefined;
}): string {
  const normalizedBrandName = brandName?.trim();

  if (normalizedBrandName) {
    return normalizedBrandName;
  }

  const normalizedDisplayName = displayName?.trim();

  if (normalizedDisplayName) {
    return normalizedDisplayName;
  }

  return tenantSlug?.trim() || "tenant";
}

export function getInviteShareDefinition(inviteKind: InviteShareKind): InviteShareDefinition {
  return INVITE_SHARE_DEFINITIONS[inviteKind];
}

export function buildInviteShareMessage({
  tenantName,
  inviteKind,
  inviteUrl
}: {
  tenantName: string;
  inviteKind: InviteShareKind;
  inviteUrl: string;
}): string {
  const { title, actionDescription } = getInviteShareDefinition(inviteKind);
  const normalizedTenantName = tenantName.trim() || "tenant";
  const heading = `【${normalizedTenantName}】${title}`;

  return `${heading}\n\nLINEアプリで下記URLを開き、${actionDescription}\n\n${inviteUrl}`;
}
